export default {
  setSocialMedias(state, medias) {
    state.socialMedias = medias;
  },
};
